@if (cardModalService.showModal()) {
    <div class="wk-cm__card-panel__tax-left">
        <section class="wk-cm__card-panel__tax__dates">
            <div
                class="wk-cm__card-panel__tax__date-needed calendar_data date_format"
                (click)="dateNeededCalendar.toggle()"
                (keydown.enter)="dateNeededCalendar.toggle()"
                (focus)="dateNeededTooltipOpen = false"
                (blur)="dateNeededTooltipOpen = false"
                (mouseenter)="dateNeededTooltipOpen = true"
                (mouseleave)="dateNeededTooltipOpen = false"
                aria-hidden="true"
            >
                @if (cardModalService.cardModalFormGroup().get("dateNeeded")?.value) {
                    <tooltip-pds3
                        mode="description"
                        position="top"
                        [openDelay]="600"
                        [closeDelay]="50"
                        targetSelector=".wk-cm__card-panel__tax__date-needed"
                        flowClass="tooltip--non-interactive"
                        [isOpen]="dateNeededTooltipOpen"
                    >
                        {{ "CardModal.Deadline" | translate }}
                    </tooltip-pds3>
                }

                <kendo-datepicker
                    #dateNeededCalendar
                    [format]="dateFormat"
                    [placeholder]="'CardModal.Deadline' | translate"
                    formControlName="dateNeeded"
                >
                    <kendo-datepicker-messages today="{{ 'Code.Today' | translate }}" toggle="{{ 'CardModal.ToggleCalendar' | translate }}" />
                </kendo-datepicker>
            </div>
            <div class="wk-cm__card-panel__tax__number-of-days-since-start calendar_data">
                <tooltip-pds3
                    mode="description"
                    position="top"
                    [openDelay]="600"
                    [closeDelay]="50"
                    targetSelector=".wk-cm__card-panel__tax__number-of-days-since-start"
                    flowClass="tooltip--non-interactive"
                >
                    {{ "Tooltips.NumberOfDaysSinceStart" | translate }}
                </tooltip-pds3>

                <wk-icon-stopwatch-sprite-pds3 />
                <icon-pds3 name="wk-icon-stopwatch" />
                <span class="calender_info">{{ cardDataToShowInModal.calculatedFields.daysSinceReady }} {{ "CardModal.Days" | translate }}</span>
            </div>
            <div class="wk-cm__card-panel__tax__step-warning calender_data">
                <tooltip-pds3
                    mode="description"
                    [openDelay]="600"
                    [closeDelay]="50"
                    position="top"
                    targetSelector=".wk-cm__card-panel__tax__step-warning"
                    flowClass="tooltip--non-interactive"
                >
                    {{ "Tooltips.NumberOfDaysSinceColumn" | translate }}
                </tooltip-pds3>

                <kendo-datepicker
                    #snoozeAlertCalendar
                    [title]="' '"
                    adaptiveMode="auto"
                    formControlName="quietDate"
                    [disabledDates]="disabledDates"
                    [readonly]="!cardDataToShowInModal.calculatedFields.isStepWarning && !cardDataToShowInModal.calculatedFields?.isStepAlert"
                    (valueChange)="onChange($event)"
                    [class.no-warning]="!cardDataToShowInModal.calculatedFields.isStepWarning"
                    [class.no-alert]="!cardDataToShowInModal.calculatedFields.isStepAlert"
                >
                    <kendo-datepicker-messages today="{{ 'Code.Today' | translate }}" toggle="{{ 'CardModal.ToggleCalendar' | translate }}" />
                </kendo-datepicker>
            </div>
            <div
                class="wk-cm__card-panel__tax__date-received calendar_data inbox_format"
                (click)="dateReceivedCalendar.toggle()"
                (keydown.enter)="dateReceivedCalendar.toggle()"
                (focus)="dateReceivedTooltipOpen = false"
                (blur)="dateReceivedTooltipOpen = false"
                (mouseenter)="dateReceivedTooltipOpen = true"
                (mouseleave)="dateReceivedTooltipOpen = false"
                aria-hidden="true"
            >
                @if (cardModalService.cardModalFormGroup().get("documentsReceivedDate")?.value) {
                    <tooltip-pds3
                        mode="description"
                        position="top"
                        [openDelay]="600"
                        [closeDelay]="50"
                        targetSelector=".wk-cm__card-panel__tax__date-received"
                        flowClass="tooltip--non-interactive"
                        [isOpen]="dateReceivedTooltipOpen"
                    >
                        {{ "CardModal.DateReceived" | translate }}
                    </tooltip-pds3>
                }
                <kendo-datepicker
                    #dateReceivedCalendar
                    adaptiveMode="auto"
                    [format]="dateFormat"
                    [placeholder]="'CardModal.DateReceived' | translate"
                    formControlName="documentsReceivedDate"
                >
                    <kendo-datepicker-messages today="{{ 'Code.Today' | translate }}" toggle="{{ 'CardModal.ToggleCalendar' | translate }}" />
                </kendo-datepicker>
            </div>
        </section>
        <tabs-pds3 htmlId="tabs-follow-up" class="wk-cm__card-panel__tax__follow-up" srLabel="follow-up-tabs" selectedTabId="FollowUpInfo">
            <tablist-pds3>
                <tab-pds3 tabId="FollowUpInfo">{{ "CardModal.FollowUpInfo" | translate }}</tab-pds3>
                <tab-pds3 tabId="EFILEStatuses">{{ "CardModal.EFILEStatuses" | translate }}</tab-pds3>
                <tab-pds3 tabId="ReturnStatusHistory">{{ "CardModal.ReturnStatusHistory" | translate }}</tab-pds3>
            </tablist-pds3>
            <tab-line-pds3 />
            <tab-panels-pds3>
                <tab-panel-pds3 panelId="FollowUpInfo">
                    <follow-up-info
                        [member]="cardModalService.selectedTaxpayer()"
                        (statusChanged)="updateCardStatus($event)"
                        (categoryChanged)="updateCardCategory($event)"
                        (categoriesViewModelChanged)="setCategoriesViewModel($event)"
                    />
                </tab-panel-pds3>
                <tab-panel-pds3 panelId="EFILEStatuses" class="wk-cm__card-panel__tax__status-efiles">
                    <div class="wk-cm__card-panel__tax__status-efile">
                        <label>{{ "CardModal.T1" | translate }}</label>
                        <div>{{ cardDataToShowInModal.eFileData.t1 | wkTranslate }}</div>
                    </div>
                    <div class="wk-cm__card-panel__tax__status-efile">
                        <label>{{ "CardModal.TP1" | translate }}</label>
                        <div>{{ cardDataToShowInModal.eFileData.tp1 | wkTranslate }}</div>
                    </div>
                </tab-panel-pds3>
                <tab-panel-pds3 panelId="ReturnStatusHistory" class="wk-cm__card-panel__tax__return-status-history">
                    <wk-status-history [statuses]="cardDataToShowInModal.statusData.CuteStatusesHistory" />
                </tab-panel-pds3>
            </tab-panels-pds3>
        </tabs-pds3>
        @if (cardModalService.cardType() === applicationTypes.TaxprepT1) {
            <wk-taxprep-notes-panel />
        } @else if (cardModalService.cardType() === applicationTypes.iFirmTaxT1) {
            <wk-ifirmtaxprep-notes-panel [id]="cardModalService.currentCard()?.documentId" />
        }
        <accordion-pds3 class="wk-cm__card-panel__tax__complexity-tags">
            <accordion-item-pds3 [isOpen]="isComplexitySectionOpen" (userRequest)="handleAccordianState($event)">
                <accordion-item-header-pds3 *accordionItemHeading2Pds3>{{ "CardModal.ComplexityTags" | translate }}</accordion-item-header-pds3>
                <div *accordionItemBodyPds3 class="wk-cm__card-panel__tax__complexity-tags-content">
                    @if (cardDataToShowInModal.Tags) {
                        @for (tag of cardDataToShowInModal.Tags; track tag.Id) {
                            <tag-pds3 #complexityTag type="dark" [flowClass]="'cg3-tag-' + tag.Id">{{ tag.Name | wkTranslate }}</tag-pds3>
                        }
                        <span class="ellipsis" [class.ellipsis--visible]="isEllipsis">...</span>

                        @if (isTagGroupOverflow) {
                            <tooltip-pds3
                                mode="description"
                                position="top"
                                targetSelector=".wk-cm__card-panel__tax__complexity-tags .ellipsis"
                                elementId="tooltip-top"
                            >
                                @if (tagsToShowInTooltip) {
                                    @for (tag of tagsToShowInTooltip; track tag.Id) {
                                        <tag-pds3 type="dark" [flowClass]="'cg3-tag-' + tag.Id"> {{ tag.Name | wkTranslate }} </tag-pds3>
                                    }
                                }
                            </tooltip-pds3>
                        }
                    }
                </div>
            </accordion-item-pds3>
        </accordion-pds3>
    </div>
    <div class="wk-cm__card-panel__tax-right fancy-scrollbar-newUI fancy-scrollbar-small">
        <wk-delivery-methods-panel />

        <accordion-pds3>
            <accordion-item-pds3
                [isOpen]="accordionsService.getAccordionState()('Accordion_ContactInfo')"
                (userRequest)="accordionsService.setAccordionState('Accordion_ContactInfo', $event)"
            >
                <accordion-item-header-pds3 *accordionItemHeading2Pds3>{{ "CardModal.ContactInfo" | translate }}</accordion-item-header-pds3>
                <div *accordionItemBodyPds3>
                    <wk-groups-methods-panel [type]="CardPanelType.Contact" />
                    <wk-assignees-tax-panel [cardDataToShowInModal]="cardDataToShowInModal" [type]="CardPanelType.Contact" />
                </div>
            </accordion-item-pds3>

            <accordion-item-pds3
                [isOpen]="accordionsService.getAccordionState()('Accordion_Assignees')"
                (userRequest)="accordionsService.setAccordionState('Accordion_Assignees', $event)"
            >
                <accordion-item-header-pds3 *accordionItemHeading2Pds3>{{ "CardModal.AssignedTo" | translate }}</accordion-item-header-pds3>
                <div *accordionItemBodyPds3><wk-assignees-tax-panel [cardDataToShowInModal]="cardDataToShowInModal" /></div>
            </accordion-item-pds3>
        </accordion-pds3>
    </div>
}
